import { DEFAULT_INPUT_PROPS } from 'src/components/BriefForm';
import BriefTextField from 'src/components/BriefTextField/BriefTextField';
import { PRODUCT_DESCRIPTION_MAX_CHARS } from 'src/data/brief';
import { countChars } from 'src/lib/string';

import { useStyles } from './useStyles';

export const TextArea = ({
  className,
  classes,
  title,
  body,
  onChange,
  bodyMaxChars = PRODUCT_DESCRIPTION_MAX_CHARS,
  disabled,
}) => {
  const styles = useStyles();

  const charCounter = {
    value: countChars(body),
    max: bodyMaxChars,
    strict: true,
  };
  return (
    <div>
      <div className={styles.title}>{title}</div>
      <BriefTextField
        charCounter={charCounter}
        className={className}
        disabled={disabled}
        displayCharCounter={false}
        InputProps={{
          name: 'body',
          ...DEFAULT_INPUT_PROPS,
          rows: 2,
          rowsMax: null,
          disabled,
        }}
        onChange={onChange}
        value={body}
        classes={classes}
      />
    </div>
  );
};
